import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './review.module.scss';
import { CustomButton } from '../../../../../shared/customButton';
import { createOneWayInterviewTemplate } from '../../../../../../services/util/oneWayInterviewTemplates';
import { useHistory } from 'react-router-dom';

const OneWayInterviewReview = (props) => {
    const [state, setState] = useState(false);
    const history = useHistory();

    const submitDetails = async () => {
        setState(true)
        let results = await createOneWayInterviewTemplate(props.oneWayInterview.interview_name);
        if (results.success === true) {
            setState(false);
            props.handleClose();
            history.push(`/app/company/interview-template/${results.data.one_way_template_id}/edit`)
        }
        else {
            setState(false);
        }
    }

    return (
        <div>
            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column">
                        <div className={styles.rowSubTitle}>Template Name</div>
                        <div className={styles.rowValues}>{props.oneWayInterview.interview_name}</div>
                    </Col>
                </Row>
            </Container>
            <hr className={styles.dividerLine} />
            <Row className={styles.actionBtnRow}>
                <div className={styles.navigateBtnCol}>
                    {<CustomButton
                        id="one_way_template_confirm"
                        buttonType="submit"
                        label="Submit"
                        type="primaryBtn"
                        disabled={state === true ? true : false}
                        backicon={
                            state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                : ''
                        }
                        handleClick={() => submitDetails()}
                    />}

                </div>
                <div className={styles.navigateBtnCol}>
                    {<CustomButton
                        id="one_way_template_review_cancel"
                        buttonType="button"
                        label="Back"
                        type="secondaryBtn"
                        handleClick={() => props.previousPage(1)}

                    />}
                </div>
            </Row>

        </div>

    )
}
export default OneWayInterviewReview;